import { SearchableConversationFilterInput } from 'generated-graphql/types';
import { useDebounce } from '@uidotdev/usehooks';
import { useState } from 'react';
import { getConversationFiltersFromFilterValue } from '../utils/getConversationFiltersFromFilterValue';
import { buildParticipantNameSearchClauses } from '../utils/buildParticipantNameSearchClauses';
import { useConversationInitialFilters } from './useConversationInitialFilters';
import {
  ConversationColumnFilter,
  ConversationTableFilter,
  ConversationTagFilter
} from '../types/ConversationTableFilter';
import { CampaignType } from 'services/campaign/types';

type Props = {
  campaignId: string;
  campaignType?: CampaignType | null;
  searchText: string;
  // One entry per selected tag key, from useConversationTagFilters.
  tagFilters?: ConversationTagFilter[];
};

export const useConversationsFilters = ({
  campaignId,
  campaignType,
  searchText,
  tagFilters = []
}: Props) => {
  const initialFilters = useConversationInitialFilters();

  const [conversationsTableFilters, setConversationsTableFilters] = useState<
    ConversationColumnFilter[] | undefined
  >(initialFilters);

  const debounceSearchNameValue = useDebounce(searchText, 500);

  const appliedFilters: ConversationTableFilter[] = [
    ...(conversationsTableFilters ?? []),
    ...tagFilters
  ];

  const andClauses = [
    ...buildParticipantNameSearchClauses(debounceSearchNameValue),
    ...(appliedFilters.length
      ? getConversationFiltersFromFilterValue(appliedFilters, campaignType)
          .and ?? []
      : [])
  ];

  const queryFilter: SearchableConversationFilterInput = {
    campaignId: {
      eq: campaignId
    },
    ...(andClauses.length > 0 ? { and: andClauses } : {})
  };

  return {
    queryFilter,
    isFiltering: !!appliedFilters.length || !!searchText.trim(),
    conversationsTableFilters,
    setConversationsTableFilters,
    appliedFilters
  };
};
